function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
  id: "warning-hi-dark_svg__a",
  "data-name": "Warning_ic_hi",
  viewBox: "0 0 192 192"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Bounding Box",
  fill: "none",
  d: "M0 0h192v192H0z"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "<Gruppe>"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M168.43 140.26c8.36 14.8 1.52 27.74-15.2 27.74H38.77c-16.72 0-23.57-12.94-15.2-27.74L80.8 35.05c8.33-14.35 22-15.11 30.41 0z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("path", {
  d: "M153.23 166H38.77c-11.42 0-18.23-6-18.74-14.58C19.53 161 26.48 168 38.77 168h114.46c12.29 0 19.24-7 18.74-16.58-.51 8.58-7.32 14.58-18.74 14.58z",
  opacity: 0.06
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  fill: "none",
  stroke: "#e60000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8,
  d: "M96 64v56.5"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "<Pfad>",
  cx: 96,
  cy: 139.89,
  r: 6,
  fill: "#e60000"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Warning_ic"
}, /*#__PURE__*/React.createElement("use", {
  "data-name": "Warning_ic_hi",
  width: 192,
  height: 192,
  xlinkHref: "#warning-hi-dark_svg__a"
}));

var SvgWarningHiDark = function SvgWarningHiDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2);
};

export default SvgWarningHiDark;